import Box from '@mui/material/Box';
// import WhiteInosio from '../icons/whiteinosio.svg';
import ComingSoonImg from '../icons/ComingSoon.svg';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

export default function CurrentlyUnderMaintenance() {
    
  return (
    <Grid container>
      <Grid item xs={12}>
        <Stack direction="row" justifyContent="center" alignItems="center">
          <Typography
            id="bank-detail"
            style={{
              fontFamily: "'Work Sans', sans-serif",
              fontStyle: 'normal',
              fontWeight: 'normal',
              fontSize: '24px',
              lineHeight: '22px',
              color: '#000000',
              marginTop: '28px',
              marginBottom: '28px',
              marginLeft: '10px',
              marginRight: '10px',
            }}
          >
            Pardon the virtual dust. We are currently deploying an update to our app.
            <br />
            <br /> We will be available shortly.
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Box height="100%" width="100%" display="flex" justifyContent="center" alignItems="center">
          <img src={ComingSoonImg} alt="Confirmation" style={{ width: '250px' }} />
        </Box>
      </Grid>
    </Grid>
  );
}
